/**
 * Analytics related code
 *
 * Potentially blocked so need to isolate it
 */
const analytics = () => {

  const clickHandlers = () => {
    // has attr data-click-data-layer
    const els = document.querySelectorAll('[data-click-data-layer]');
    els.forEach(el => {
      // check if data-is-analytics-init is set
      if (el.getAttribute('data-is-analytics-init') === 'true') {
        return;
      }
      el.setAttribute('data-is-analytics-init', 'true');
      el.addEventListener('click', (e) => {

        // temp: testing
        // e.preventDefault();

        const data = el.getAttribute('data-click-data-layer');
        const dataObj = JSON.parse(data);

        console.log( 'data', dataObj, data );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataObj);

      });
    });
  };

  const init = () => {
    clickHandlers();
  };

  init();

  window.addEventListener( 'BioRexMovieAjaxReady', () => {
    clickHandlers();
  } );

  window.addEventListener( 'BioRexShoppingCartSubmit', (e) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'WebshopVouchersShoppingCart',
      'eventAction': 'submit',
    });
  } );

};

analytics();
